<form 	*ngIf="orderItem"
		class="callable-order-item card-info-block"
		[class.four-columns-step-info-no-ship-to]="isFourColumnsStepInfoNoShipTos()"
		[class.four-columns-step-summary-no-ship-to]="isFourColumnsStepSummaryNoShipTos()"
		[class.five-columns-step-summary-no-ship-to]="isFiveColumnsStepSummaryNoShipTos()"
		[class.five-columns-step-summary-ship-to]="isFiveColumnsStepSummaryShipTos()"
		[class.six-columns-step-summary-no-ship-to]="isSixColumnsStepSummaryNoShipTos()"
		[class.six-columns-step-info-no-ship-to]="isSixColumnsStepInfoNoShipTos()"
		[class.seven-columns]="isSevenColumns()"
		[class.seven-columns-no-shipto]="isSevenColumnsNoShipTo()"
		[class.seven-columns-step-summary-no-ship-to]="isSevenColumnsStepSummaryNoShipTo()"
		[class.eight-columns]="isEightColumns()"
		[class.eight-columns-step-summary]="isEightColumnsStepSummary()"
		[formGroup]="formGroup">
	<!-- Customer order number / callable weight column -->
	<div class="customer-order-number">
		<div translate class="card-content-label">filter.customerOrderNumber</div>
		<div class="big-font" [title]="'filter.customerOrderNumber' | translate">{{ getCustomerOrderNumber() }}</div>
		<!-----Mill---->
		<div>
			<span *ngIf="orderItem.millDescription">
				<div class="card-content-label" translate>datacenter-shipment.mill</div>
				<div>{{orderItem.millDescription}}</div>
			</span>
		</div>
	</div>
	<!-- Supplier order number column -->
	<div class="supplier-order-number">
		<div translate class="card-content-label">filter.supplierOrderNumber</div>
		<div>{{ getSupplierOrderNumber() }}</div>
		<!--  Ship To -->
		<span>
			<div class="card-content-label" translate>ecall-off.ship-to</div>
			<div>{{orderItem.shipToDescription}}</div>
		</span>
	</div>
	<!--  Unloading reference / Steelgrade / dimensions column -->
	<mat-form-field *ngIf="editUnloadingReference" class="unloading-reference" subscriptSizing="dynamic" floatLabel="always">
		<mat-label translate>ecall-off.unloading-reference</mat-label>
		<input matInput formControlName="unloadingReference" type="text" spellcheck="false"
			maxlength="64" autocomplete="off">
		<mat-icon class="accent" matSuffix svgIcon="md:edit"></mat-icon>
	</mat-form-field>
	<div *ngIf="!editUnloadingReference && showUnloadingReference" class="unloading-reference comment-block">
		<div translate class="card-content-label">ecall-off.unloading-reference</div>
		<span [matTooltip]="orderItem.unloadingReference ?  getTooltipText(orderItem.unloadingReference) : UNDERSCORE">
				{{ orderItem.unloadingReference ? orderItem.unloadingReference : UNDERSCORE }}
		</span>
	</div>
	<!-- Requested Ship To -->
	<mat-form-field subscriptSizing="dynamic" floatLabel="always"
			*ngIf="shipToDetails && shipToDetails.length > 0 && orderItem.allowChangeOfShipto === 1; else noShipToDescription">
		<mat-label translate>ecall-off.requested-ship-to</mat-label>
		<mat-select formControlName="shipTo" [compareWith]="compareShipTo" (selectionChange)="onShipToChange($event.value)">
			<mat-option *ngFor="let shipTo of shipToDetails" [value]="shipTo">
				{{ shipTo.shipToDescription }}
			</mat-option>
		</mat-select>
	</mat-form-field>
	<ng-template #noShipToDescription>
		<span>
			<div class="card-content-label" translate>ecall-off.requested-ship-to</div>
			<div>{{orderItem.shipToDescription}}</div>
		</span>
	</ng-template>
	<div *ngIf="!editUnloadingReference && !showUnloadingReference" class="two-fields-wrapper">
		<div class="steelgrade">
			<div translate class="card-content-label">order.steelgrade</div>
			<div>{{ orderItem.steelgradeDescription ?? UNDERSCORE }}</div>
		</div>
		<div class="dimensions">
			<div translate class="card-content-label">order-tracking.dimension</div>
			<div>{{ orderItem | copoDimension }}</div>
		</div>
	</div>
	<!-- Dates column -->
	<div *ngIf="editDateFrom || editDateTo" class="dates two-fields-wrapper">
		<mat-form-field *ngIf="editDateFrom" class="date-from" subscriptSizing="dynamic" floatLabel="always">
			<mat-label>{{ (editDateTo ? 'filter.number.from' : 'ecall-off.requested-date') | translate }}</mat-label>
			<input [matDatepickerFilter]="dateFilter" #requestedDeliveryDateFromInput
					formControlName="requestedDeliveryDateFrom"
					matInput copoFormat="date" spellcheck="false" autocomplete="off" readonly required
					[copoDatepicker]="requestedDeliveryDateFromDatepicker"
					[max]="getMaxFromDate()"
					(click)="requestedDeliveryDateFromDatepicker.open()"
					(focus)="requestedDeliveryDateFromInput.blur()">
			<mat-datepicker-toggle 	matSuffix [for]="requestedDeliveryDateFromDatepicker" class="accent">
			</mat-datepicker-toggle>
			<mat-datepicker #requestedDeliveryDateFromDatepicker [startAt]="CURRENT_DATE">
			</mat-datepicker>
			<mat-error translate>ecall-off.required</mat-error>
		</mat-form-field>
		<mat-form-field *ngIf="editDateTo" class="date-to" subscriptSizing="dynamic" floatLabel="always">
			<mat-label>{{ (editDateFrom ? 'filter.date.to' : 'ecall-off.requested-date') | translate }}</mat-label>
			<input [matDatepickerFilter]="dateFilter"	#requestedDeliveryDateToInput
					formControlName="requestedDeliveryDateTo"
					matInput copoFormat="date" spellcheck="false" autocomplete="off" readonly required
					[copoDatepicker]="requestedDeliveryDateToDatepicker"
					[min]="getMinToDate()"
					(click)="requestedDeliveryDateToDatepicker.open()"
					(focus)="requestedDeliveryDateToInput.blur()">
			<mat-datepicker-toggle 	matSuffix [for]="requestedDeliveryDateToDatepicker" class="accent">
			</mat-datepicker-toggle>
			<mat-datepicker #requestedDeliveryDateToDatepicker [startAt]="CURRENT_DATE">
			</mat-datepicker>
			<mat-error translate>ecall-off.required</mat-error>
		</mat-form-field>
	</div>
	<div *ngIf="!editDateFrom && showDates && (orderItem.requestedDeliveryDateFrom || orderItem.requestedDeliveryDateTo)" class="dates two-fields-wrapper">
		<div *ngIf="orderItem.requestedDeliveryDateFrom" class="date-from">
			<div class="card-content-label">{{ (orderItem.requestedDeliveryDateTo && orderItem.requestedDeliveryDateTo !== orderItem.requestedDeliveryDateFrom ? 'filter.number.from' : 'ecall-off.requested-date') | translate }}</div>
			<div>{{ orderItem.requestedDeliveryDateFrom | copoDate:'date' }}</div>
		</div>
		<div *ngIf="orderItem.requestedDeliveryDateTo && orderItem.requestedDeliveryDateTo !== orderItem.requestedDeliveryDateFrom" class="date-to">
			<div class="card-content-label">{{ (orderItem.requestedDeliveryDateFrom ? 'filter.date.to' : 'ecall-off.requested-date') | translate }}</div>
			<div>{{ orderItem.requestedDeliveryDateTo | copoDate:'date' }}</div>
		</div>
	</div>
	<!-- Comment column -->
	<div *ngIf="showComment" class="comment">
		<span mat-ripple>
			<mat-icon svgIcon="comment"></mat-icon>
		</span>
		<span class="text comment-block" [matTooltip]="orderItem.comment && orderItem.comment.length > 0 ? orderItem.comment : UNDERSCORE">{{orderItem.comment && orderItem.comment.length > 0 ? orderItem.comment : UNDERSCORE}}</span>
	</div>
	<!-- Called volume column -->
	<mat-form-field class="called-volume-wrapper" subscriptSizing="dynamic" *ngIf="editCalledVolume">
		<mat-label>{{ 'ecall-off.called-volume' | translate }}</mat-label>
		<input type="text" matInput [class.empty]="!formGroup.get('calledVolume')?.value" name="calledVolume"
			formControlName="calledVolume"
			[placeholder]="'ecall-off.max' | translate: {value: (this.orderItem.qtyBatchGross | number:'1.0-1') ?? ''}"
			[title]="'ecall-off.max' | translate: {value: this.orderItem.qtyBatchGross ?? ''}">
		<button type="button" mat-icon-button matSuffix *ngIf="orderItem.calledWeight || getCalledVolumeError() !== null" (click)="onCalledVolumeReset()">
			<mat-icon class="reset" svgIcon="delete"></mat-icon>
		</button>
		<mat-error *ngIf="getCalledVolumeError()?.key">{{ getCalledVolumeError()!.key | translate: getCalledVolumeError()?.params }}</mat-error>
		<mat-error *ngIf="isLessThanBatchMinQty"><span translate>datacenter.minimal-quantity-for-this-item-is</span> {{minBatchQty}}</mat-error>
		<mat-error *ngIf="isInvalid" translate>datacenter.requested-quantity-is-greater-than-the-maximum-value</mat-error>
	</mat-form-field>
	<div *ngIf="!editCalledVolume" class="value">{{ orderItem.calledWeight ?? '-' }}</div>
	<!-- Menu -->
	<!-- !! Display outside of the component into an overlay !! -->
	<button type="button" class="menu trigger-button" *ngIf="showMenu" mat-icon-button [matMenuTriggerFor]="menu">
		<mat-icon svgIcon="md:more_vert"></mat-icon>
	</button>
	<mat-menu #menu="matMenu" xPosition="before" yPosition="below">
		<button type="button" mat-menu-item (click)="openCommentDialog()">
			<span class="comment-label" [class.edit]="formGroup.get('comment')?.value" translate>ecall-off.exception</span>
		</button>
		<mat-divider></mat-divider>
		<button type="button" mat-menu-item (click)="onView()">
			<span translate>product.table.header.view</span>
		</button>
		<mat-divider></mat-divider>
		<button type="button" mat-menu-item (click)="onDelete()">
			<span translate>eoffer.action.delete</span>
		</button>
	</mat-menu>
</form>